interface StatsCardProps {
  icon: React.ReactNode;
  title: string;
  value: number | string;
  bgColor?: string;
  iconColor?: string;
}

export default function JobStatsCard({ icon, title, value }: StatsCardProps) {
  return (
    <div className="bg-white rounded-lg shadow-sm border p-6">
      <div>
        <p className="text-sm font-medium text-gray-500 mb-4">
          {title}
        </p>
        <div className="flex items-center">
          <div className="flex-shrink-0">
            <div className="w-8 h-8 bg-blue-100 rounded-lg flex items-center justify-center">
              {icon}
               
            </div>
          </div>
          <div className="ml-4">
            <p className="text-2xl font-semibold text-gray-900">
              {value}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
